import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../image/QRcode.png'


const _withScopeId = n => (_pushScopeId("data-v-75d5e29a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "f7-icons size-22" }, "globe", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("言語")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("日本語")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("英語")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "login-status" }, "宿泊者カードを登録しました。"),
  /*#__PURE__*/_createElementVNode("div", { class: "login-content login-content-thanks" }, "ご登録ありがとうございました。"),
  /*#__PURE__*/_createElementVNode("div", { class: "login-content content-one" }, "チェックイン用QRコード"),
  /*#__PURE__*/_createElementVNode("div", { class: "login-content" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "imgsize",
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("QR code")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "login-content" }, "チェックイン日：2022/1/25 15:00"),
  /*#__PURE__*/_createElementVNode("div", { class: "login-content content-two" }, "Hotel HOS-1-1"),
  /*#__PURE__*/_createElementVNode("div", { class: "login-content content-three" }, "電話："),
  /*#__PURE__*/_createElementVNode("div", { class: "login-content" }, "E-Mail：info@testl.test")
], -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" TOP ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f7_button = _resolveComponent("f7-button")!
  const _component_f7_navbar = _resolveComponent("f7-navbar")!
  const _component_f7_actions_label = _resolveComponent("f7-actions-label")!
  const _component_f7_actions_button = _resolveComponent("f7-actions-button")!
  const _component_f7_actions_group = _resolveComponent("f7-actions-group")!
  const _component_f7_actions = _resolveComponent("f7-actions")!
  const _component_f7_block = _resolveComponent("f7-block")!
  const _component_f7_page = _resolveComponent("f7-page")!

  return (_openBlock(), _createBlock(_component_f7_page, { style: {"background-color":"#FFF","transform":"translate3d(0, 0, 0)"} }, {
    default: _withCtx(() => [
      _createVNode(_component_f7_navbar, { title: "登録完了" }, {
        default: _withCtx(() => [
          _createVNode(_component_f7_button, {
            class: "col",
            raised: "",
            "actions-open": "#actions-one-group"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_f7_actions, { id: "actions-one-group" }, {
        default: _withCtx(() => [
          _createVNode(_component_f7_actions_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_f7_actions_label, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_f7_actions_button, { bold: "" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_f7_actions_button, null, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_5,
      _createVNode(_component_f7_block, null, {
        default: _withCtx(() => [
          _createVNode(_component_f7_button, {
            fill: "",
            preloader: "",
            large: "",
            href: "/:token/registration/detail/",
            style: {"width":"90%","margin":"0 auto"}
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}